import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Brand from '../../components/Common/Brand';
import CounterStyleThree from '../../components/Elements/Counter/CounterStyleThree';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleService from '../../components/Service/SingleService';
import ProgressBar from '../../components/Elements/Progress/ProgressBar';
import ScrollToTop from '../../components/Common/ScrollTop';

// Layout Components
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';

const SoftwareDevelopment = () => {
    const [serviceData, setServiceData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('https://yautiktechnology.com/api/service/MobileApp')
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((data) => {
                setServiceData(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <React.Fragment>
            <Header parentMenu='page' secondParentMenu='App Development' activeMenu='/services' />
            <SiteBreadcrumb
                pageTitle="App Development"
                titleClass="page-title"
                pageName="Services"
                breadcrumbsImg={require('../../assets/img/breadcrumbs/3.jpg')}
            />

            <div className="rs-about pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pr-40 md-pr-14 md-mb-50">
                            <SectionTitle
                                sectionClass="sec-title4"
                                subtitleClass="sub-text"
                                subtitle="Mobile App Development"
                                titleClass="title"
                                title={serviceData.heading}
                                effectClass="heading-line"
                            />
                            <SectionTitle
                                sectionClass="sec-title4"
                                descClass="desc desc-big"
                                description={serviceData.description}
                                secondDescClass="desc"
                                titleClass1="title1"
                                title1={serviceData.keyFeature}
                                subtitleClass1="subtitle1"
                                subtitle1={serviceData.subHeading1}
                                secondDescription={serviceData.subHeadingDesc1}
                                subtitleClass2="subtitle2"
                                subtitle2={serviceData.subHeading2}
                                desc2={serviceData.subHeadingDesc2}
                                subtitleClass3="subtitle3"
                                subtitle3={serviceData.subHeading3}
                                desc3={serviceData.subHeadingDesc3}
                                subtitleClass4="subtitle4"
                                subtitle4={serviceData.subHeading4}
                                desc4={serviceData.subHeadingDesc4}
                                subtitleClass5="subtitle5"
                                subtitle5={serviceData.subHeading5}
                                desc5={serviceData.subHeadingDesc5}
                            />
                            <div className="btn-part mt-46">
                                <Link to="/contact">
                                    <a className="readon learn-more">Contact Us</a>
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="images">
                                <img src={require('../../assets/img/about/1.jpg')} alt="Software Details" />
                            </div>
                        </div>
                    </div>

                    <div className="rs-services style5 pt-120 md-pt-80">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 md-mb-30">
                                    <SingleService
                                        itemClass="services-item"
                                        serviceImage={require('../../assets/img/service/style7/1.png')}
                                        Title={serviceData.expHeading}
                                        Text={serviceData.expDesc}
                                    />
                                </div>
                                <div className="col-lg-4 md-mb-30">
                                    <SingleService
                                        itemClass="services-item"
                                        serviceImage={require('../../assets/img/service/style7/2.png')}
                                        Title={serviceData.processHeading}
                                        Text={serviceData.processDesc}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <SingleService
                                        itemClass="services-item"
                                        serviceImage={require('../../assets/img/service/style7/3.png')}
                                        Title={serviceData.ideaHeading}
                                        Text={serviceData.ideaDesc}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="rs-about gray-bg pt-120 pb-120 md-pt-80 md-pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 pr-46 md-pr-15 md-mb-50">
                            <div className="choose-img">
                                <img className="main" src={require('../../assets/img/choose/3.png')} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <SectionTitle
                                sectionClass="sec-title mb-30"
                                subtitleClass="sub-text choose"
                                subtitle="Why Choose Us"
                                titleClass="title pb-20"
                                title={serviceData.businessHeading}
                                descClass="desc"
                                description={serviceData.businessDesc}
                            />
                            <div className="row">
                                <div className="col-lg-10">
                                    <div className="rs-skillbar style1 modify1">
                                        <div className="cl-skill-bar">
                                            <ProgressBar
                                                completed={92}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Software Development"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={80}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Cyber Security"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={95}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Artificial Intelligence"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={78}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Web Development"
                                                ProgressParent="main-div"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CounterStyleThree />
            <Brand />
            <ScrollToTop />
            <Footer />
            <SearchModal />
        </React.Fragment>
    );
};

export default SoftwareDevelopment;
